import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { usePopup } from '../context/PopupContext';
import LeadForm from './LeadForm';

export default function PopupForm() {
  const { isOpen, closePopup, packageInfo } = usePopup();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) closePopup(); }}>
      <DialogContent
        data-testid="popup-form-dialog"
        className="bg-[#121E3D] border border-[#1D2D50] text-white max-w-md sm:max-w-lg p-0 overflow-hidden"
      >
        <div className="bg-gradient-to-r from-[#D4AF37]/10 to-transparent p-6 pb-4">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold font-['Outfit'] text-white">
             Take the First Step Toward Brand Protection
            </DialogTitle>
            <DialogDescription className="text-[#A0AABF] text-sm mt-1">
              Protect your brand today. Fill in the details below and our experts will get in touch.
            </DialogDescription>
          </DialogHeader>
        </div>
        <div className="p-6 pt-2">
          <LeadForm
            packageTitle={packageInfo.title}
            packageAmount={packageInfo.amount}
            tmSignUpType={packageInfo.tmSignUpType}
            onSuccess={closePopup}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
